import { render } from "./ListDevices.component.vue?vue&type=template&id=8ca551f4&ts=true"
import script from "./ListDevices.component.vue?vue&type=script&lang=ts"
export * from "./ListDevices.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__